<template>
	<section class="InputField" :class="{multiline}">
		<p>{{ msg }}</p>
		<div class="input-area">
			<textarea class="input" ref="input" v-model="text" :rows="1" placeholder="メッセージ"></textarea>
			<A class="icon-paper-plane" @click="onSendMessage" :disabled="!valid"></A>
		</div>
	</section>
</template>

<script>
	import { testMatch } from '../../libs/utils';
	import { mapState } from 'vuex';
	import { sendDM } from '../../services/history';

	export default {
		props: ['ipts', 'msg', 'action'],
		data() {
			return {
				text: ''
			};
		},

		mounted() {
			this.logX(this.ipts);
			this.$refs.input.focus();
			this.$refs.input.addEventListener('keydown', e => {
				if (e.key.toLowerCase() === 'enter') {
					if ((this.multiline && (e.ctrlKey || e.metaKey)) || (!this.multiline && !(e.ctrlKey || e.metaKey || e.shiftKey))) {
						e.preventDefault();
						e.stopPropagation();
						if (this.valid) {
							this.onSendMessage();
						}
					}
				}
			});
		},

		methods: {
			onSendMessage() {
				if (!this.text) return;
				if (!this.readonly) {
					this.$emit('submit', this.text);
				} else {
					sendDM(this.text);
				}
				// this.text = '';
			}
		},

		computed: {
			...mapState(['readonly']),
			valid() {
				return testMatch(this.ipts[0], this.text);
			},
			multiline() {
				return this.ipts?.[0]?.match_type === 'pattern' && this.ipts?.[0]?.validate === 'len:1';
			}
		}
	};
</script>

<style lang="scss" scoped>
	.InputField {
		padding: 1rem 1.6rem;

		.input-area {
			display: flex;
			align-items: stretch;
			justify-content: center;
			position: relative;
			border-radius: 1rem;
			overflow: hidden;
			border: solid 1px rgba(0, 0, 0, 0.2);
			margin-top: 1rem;

			.input {
				flex: 1 1 auto;
				padding: 1rem 1.6rem;
				font-size: inherit;
				border: none;
				background-color: rgba(0, 0, 0, 0.03);
				outline: none;
				min-width: 2rem;
				resize: none;
			}

			.A {
				flex: 0 0 5rem;
				background-color: var(--clrTheme);
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 1rem 1.6rem;
				color: white;
				font-size: 2rem;
			}
		}
	}
</style>
